import {BaseModel} from '../../_base/crud';

export class RegNumberModel extends BaseModel {
    id: number;

    label: string;
    code: number;
    created_at: Date;
    updated_at: Date;

    clear(): void {
        this.id = undefined;
        this.label = '';
        this.code = undefined;
        this.created_at = new Date();
        this.updated_at = new Date();
    }
}
